import { apiSlice } from "./ApiSlice";

const GetdepartsmentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    Getdepartment: builder.query({
      query: ({clinicId,specialization}) => {
       
        return {
          url: `/api/ClinicProfile/GetDepartmentDoctors?userClinicID=${clinicId}&specialization=${specialization}`,
          method: "GET"
        };
      },
    }),
  }),
});

export const { useLazyGetdepartmentQuery } = GetdepartsmentsApiSlice;